export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";